import { render, staticRenderFns } from "./SDKComplianceGuidelines.vue?vue&type=template&id=f14b1c3a&scoped=true"
import script from "./SDKComplianceGuidelines.vue?vue&type=script&lang=js"
export * from "./SDKComplianceGuidelines.vue?vue&type=script&lang=js"
import style0 from "./SDKComplianceGuidelines.vue?vue&type=style&index=0&id=f14b1c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14b1c3a",
  null
  
)

export default component.exports